<template>
  <li>
    {{ tender.name }}
    <ul>
      <li v-for="(offer, o_idx) in offers" :key="o_idx">
        {{ offer.contractor_team.name }}
      </li>
      <li v-if="hideOffers">
        <span class="pointer text-accent" @click="openOffers"> {{ $t('Show more') }}... </span>
      </li>
    </ul>
  </li>
</template>

<script>
  const MAX_OFFERS_COUNT = 3;

  export default {
    name: 'AffectsOffersList',
    props: {
      tender: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        offersClosed: true,
      };
    },
    computed: {
      offers() {
        return this.hideOffers ? this.tender.offers.slice(0, MAX_OFFERS_COUNT) : this.tender.offers;
      },
      hideOffers() {
        return this.tender.offers.length > MAX_OFFERS_COUNT && this.offersClosed;
      },
    },
    methods: {
      openOffers() {
        this.offersClosed = false;
      },
    },
  };
</script>

<style scoped>
  ul {
    padding-left: 20px;
  }
</style>
